<template>
  <div class="">
    <van-nav-bar
      title="货空间鲸会员协议"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
        @click-right="onClickRight"
      :fixed="true"
    >
    <template #right>
      <!-- <img class="img" src="../../../assets/diq.png" alt=""> -->
    <!-- <van-icon name="down" color='#030' size="18" /> -->
  </template>
  </van-nav-bar>
    <h2>货空间鲸会员协议</h2>
    <!-- <a href="https://www.baidu.com">123</a> -->
    <p>
    生效日期: 2022-11-11         
    </p>
    <p>最近更新日期: 2024-3-26</p>
    <p>欢迎您（以下或称“用户”）使用货空间平台提供的各项功能和服务！
您与上海货空间共同签署《货空间鲸会员协议》（以下简称“本协议”），并使用您已有的货空间平台认证账号登录上海货空间平台后，您即可按照本协议约定使用上海货空间为提供的各项会员服务。
</p>
    <p>
       【审慎阅读】您在签署本协议之前，请务必审慎阅读、充分理解本协议各条款内容，特别是以粗体或下划线标识的部分。 
    </p>
    <p>
      【签署】当您使用您已有的货空间平台账号登录上海货空间平台点击阅读并同意本协议后，即表示您已审慎阅读、充分理解并完全接受本协议的全部内容，并同意与上海货空间签署本协议，本协议自您点击同意时生效。在阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止当前的开通或续费等行为，同时也可将您的宝贵意见反馈给我们。

    </p>
    <p>目 录</p>
    <p>一、释义
</p>
    <p>二、账号认证
</p>
    <p>
      三、费用标准

    </p>
    <p>
      四、线上支付与开通

    </p>
    <p>
      五、业务规则及约定

    </p>
    <p>
     六、用户的违约及处理 

    </p>
    <p>七、协议的变更及终止 
</p>
    <p>
      八、责任限制

    </p>
    <p>
      九、法律适用、管辖与其他 
    </p>
    <p>
     一、释义 

    </p>
    <p>
      1.1用户：指成功注册上海货空间账号的自然人、法人或其他组织，和签署了本协议并使用鲸会员各项服务的自然人、法人或其他组织。

    </p>
    <p>
     1.2上海货空间：指都有（上海）供应链管理有限公司，也即是上海货空间平台的运营方。

    </p>
    <p>1.3上海货空间平台：指都有（上海）供应链管理有限公司开发和运营的，为您提供各项产品及或服务的网站、客户端、移动应用程序、微信公众号、微信小程序、淘宝店铺、抖音视频号等渠道（包括未来技术发展出现的新的形态）。
</p>
    <p>
      1.4平台规则：指在上海货空间平台上已经发布的及未来根据需要不定期更新的或新发布的所有服务规则、公告及各项产品、功能及或服务的流程说明、使用方法、规则介绍等。

    </p>
    <p>
     二、账号认证

    </p>
    <p>2.1用户在签署本协议成为鲸会员前，其在上海货空间平台的注册账号必须经过平台认证，认证审核通过后，方可签署本协议。
</p>
    <p>
      2.2用户注册账号在进行认证时，应根据系统提示或平台客服人员的要求，提供必要的用户身份证明资料或相关的经营实体资料（包括但不限于营业执照、经营场所证明等）等信息，以证明用户自身的真实性以及交易的合法性。

    </p>
    <p>2.3同时，为了对用户账号和其他信息进行统一管理、加强用户信息安全保护并为用户提供更加优质、高效、全面的商品及或服务，您同意授权上海货空间按照本协议以及《货空间平台用户隐私政策》的约定收集、使用、处理、共享货空间平台下所存储的您的个人信息。 
</p>
    <p>
     三、费用标准

    </p>
    <p>
     3.1上海货空间鲸会员的收费标准为人民币2999元/年，期限为一年，自您支付成功货空间平台系统为您开通会员资格之刻起算,不论您是否使用，会员资格都将于12个月后到期，且会员资格存续期间不得转让、出借他人。

    </p>
    <p>3.2鲸会员是平台提供的一项增值服务，一经购买开通,则概不退换返还。
    </p>
    <p>3.3若由于市场行情变化、上海货空间经营策略业务调整等原因，导致上述收费标准发生变化的，在此之前，上海货空间将会以足够合理的期限提前告知于您，以确保您有充分选择的权利。 
</p>
    <p>
      四、线上支付与开通

    </p>
    <p>
      4.1货空间鲸会员资格只能在上海货空间官方网站中或货空间移动应用端内使用支付宝或微信在线支付，不接受线下付款。

    </p>
    <p>4.2线上付款成功后，系统自动为该用户账号开通鲸会员资格，并对账号做出会员标识。
</p>
    <p>
      4.3会员资格到期前15日，系统会向您发送提醒通知，通知方式包括但不限于手机短信、电子邮件、网站站内信、移动应用内系统消息等。

    </p>
    <p>
      五、业务规则与约定

    </p>
    <p>
     5.1鲸会员资格一经售出，概不退费；且平台运营方有权按照会员须知的相关条款，拒绝不符合资格的用户的会员申购，及取消不符合资格或严重违反鲸会员协议条款的相关会员的会员资格。

    </p>
    <p>5.2用户取得鲸会员资格后，在上海货空间平台上所正式提交的购货订单，在付款结清该笔订单货款后，货空间商城系统将会依据该订单上实际成交的商品品项，按平台规定的各项商品比例，计算出鲸点返利金额，记入会员账号的返利账户中，用于会员后续交易下单时抵用结算货款或平台规定的其他用途。
</p>
    <p>5.3平台当前返利比例数值设定为【0.5%、1%、1.5%、2%、2.5%、3%】，对会员有效期内下单成交并已结款的各项商品的具体返利比例将因货物品类、SKU编号的不同而不同；返利比例的设置及调整变化，最终决定权、解释权在上海货空间，但我们会在做出调整变化之时以系统消息的方式及时告知于您。
</p>
    <p>
     5.4会员取得的鲸点返利金额不具备实体货币属性，不计利息，不可提现，不可转让，只能用于货空间平台内的交易订单结抵货款用或平台规定的其他用途。

    </p>
    <p>
      5.5当您与我方之间的交易发生了退货、退款，或者最终的实际成交结果与已提交的订单金额出现差异时，我方将会依据实际退货、退款金额，以及实际出现的订单差异金额，计算出应倒找或倒扣回来的返利金额，自动调整会员的返利账户余额。

    </p>
    <p>
      5.6“天天特价”的商品不再计算给予返利；实际成交价格低于App标定售价的产品也不再计算给予返利。
    </p>
    <p>
      5.7如果会员用户的鲸点返利账户中有返利余额，那么会员用户可以自行决定在下新订单时是否使用返利余额参与订单的货款结算。若会员用户在提交订单时，选择使用返利余额参与货款结算的，则该笔交易下此购货订单上最大可使用的返利金额为不超过本订单所有商品总金额的15%；上海货空间在此提醒您，该单笔限制比例会因平台运营方经营策略改变而随之调整变动，但我方会于做出调整变动前合理期限内提前告知于您。

    </p>
    <p>
      5.8退货商品所涉及的原初始下单时所用掉的返利及优惠券，不予返还找补；
    </p>
    <p>
      5.9平台将为会员提供关于鲸点返利的明细账单与数据查询服务。会员对鲸点返利的数据及规则有疑问时，可致电货空间客服中心咨询；但最终结果以上海货空间平台系统生成并记录的数据为准，上海货空间对本平台下的会员鲸点返利拥有最终解释权。
</p>
    <p>六、用户的违约及处理
</p>
    <p>
      6.1用户购买开通会员资格后，若单方面毁约要求退费的，经双方协商达成退费合意时，平台运营方将为用户办理退费，但同时要将用户自会员开通之日起至退费之日止期间内该用户已享受的返利全部扣回，并另外加收100元的办理手续费；若拟退会员费金额在抵扣用户应退回给平台方的返利金额后，仍差欠平台返利金额的，则须继续补齐平台方应收回的返利金额之差。

    </p>
    <p>
     6.2为保护其他会员的合法权益，办理会员费退费的用户，三个月后方可再次申购会员资格；一年内办理会员费退费累计达到两次的用户，平台将有权不再接受其会员资格申购。

    </p>
    <p>七、协议的变更及终止 
</p>
    <p>
      7.1协议变更

    </p>
    <p>
     7.1.1平台可根据国家法律法规变化及维护市场秩序、保护用户合法权益需要，不时修改本协议、关联协议，变更后的协议、关联协议（下称“变更事项”）将通过法定程序并以本协议约定的有效通知方式通知您。

    </p>
    <p>
     7.1.2如您不同意变更事项，您有权于变更事项确定的生效日前联系平台运营方反馈意见。如反馈意见得以采纳，平台将酌情调整变更事项。如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用平台功能及或服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用平台功能及或服务，则视为您同意已生效的变更事项。

    </p>
    <p>
      7.2协议终止

    </p>
    <p>7.2.1您有权通过以下任一方式终止本协议：
</p>
    <p>
      在满足平台要求的账号注销条件时您通过平台自助服务注销您的账号的；

    </p>
    <p>
      变更事项生效前您停止使用平台的功能及或服务并明示不愿接受变更事项的；

    </p>
    <p>
      您明示不愿继续使用平台的功能及或服务，且符合平台要求的终止条件的。

    </p>
    <p>
      7.2.2出现以下情况时，平台可按照本协议约定的有效方式通知您终止本协议：

    </p>
   <p>
您的账号认证未通过、不再合法存续或无法有效核实；

   </p>
   <p>您违反本协议约定，平台依据违约条款终止本协议的；
</p>
   <p>您盗用他人账号、欺诈、售假、扰乱市场秩序、采取不正当手段牟利等行为，平台依据相应平台规则对您的账号予以关闭、注销的；
</p>
   <p>除上述情形外，因您多次违反平台规则相关规定且情节严重，平台依据相应平台规则对您的账户予以关闭、注销的；
</p>
   <p>平台基于合理理由相信您的行为可能会使您、平台及其他用户等相关方发生严重损害或产生法律责任</p>
   <p>您的会员资格已到期或已办理退费。
</p>
   <p>7.3协议终止后的处理
</p>
   <p>7.3.1本协议终止后，除法律有明确规定外，平台无义务向您或您指定的第三方披露您的账号及其他任何信息。
</p>
   <p>7.3.2本协议终止后，平台仍享有下列权利：
</p>
   <p>依据《中华人民共和国网络安全法》以及其他相关法律的要求，在一定期限内继续保存您留存于平台的各类信息（包括但不限于注册信息、认证信息、交易信息、资金信息等）；
</p>
   <p>对于您过往的违约行为，平台仍可依据本协议向您追究违约责任。
</p>
   <p>八、责任限制
</p>
   <p>8.1您理解并同意，您在登录平台操作使用各项功能及或服务过程中存在的风险将完全由您本人承担，平台在本协议约定的责任范围以外不承担任何责任。
</p>
   <p>8.2在法律允许的情况下，平台对于与本协议有关的任何间接的、惩罚性的、特殊的、派生的损失（包括但不限于业务损失、收益损失、利润损失、使用数据、商誉或其他经济利益的损失），不承担任何责任，即使事先已被告知此等损失的可能性。
</p>
   <p>8.3您理解并确认，对于平台向您提供的下列功能及或服务本身及其引发的任何损失，平台无需承担任何责任：
</p>
   <p>平台向您免费提供的各项产品、功能及或服务；
</p>
<p>平台向您赠送或附赠的任何产品、功能及或服务。
8.4您理解并确认，平台可能因下列情况无法正常为您提供功能及或服务，平台就此不承担损害赔偿责任：
</p>
<p>因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
</p>
<p>因电力供应故障、通讯网络故障等公共服务因素或第三人因素；
</p>
<p>在平台已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
</p>
<p>8.5您理解并同意，因您使用货空间平台的功能及或服务、违反本协议或使用您的平台账号采取的任何行动，而导致的任何第三方索赔，应且仅应由您本人承担。如果由此引起平台、员工、客户、供应商和合作伙伴被第三方索赔的，您应承担全部责任。
</p>
<p>九、法律适用、管辖与其他 
</p>
<p>9.1本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及或行业惯例。
</p>
<p>
    9.2您因使用货空间平台的功能及或服务所产生及与平台有关的争议，由平台运营方与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。

</p>
<p>9.3本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
</p>
<p>9.4本协议各条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。
</p>
<p>9.5有效联系方式
</p>
<p>9.5.1您在注册平台账号、进行账号认证时，您应该向平台提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被有效联系的状态。
</p>
<p>
    9.5.2您用于登陆平台、接收站内信、系统消息等信息的货空间账号，也作为您的有效联系方式。

</p>
<p>
    9.5.3平台将通过您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。

</p>
<p>9.6通知的送达
</p>
<p>9.6.1平台通过上述联系方式向您发出通知，其中以电子方式发出的书面通知，包括但不限于在平台公告、向您提供的联系电话发送手机短信、向您提供的电子邮件地址发送电子邮件、向您的账号发送系统消息以及站内信，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
</p>
<p>9.6.2对于在平台为您提供服务过程中引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在注册平台账号时提供的、更新的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。
</p>
<p>9.6.3您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。您同意上述送达方式适用于各个司法程序阶段。
</p>
<p>9.6.4您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。

</p>
<p>如您对本协议有任何疑问，可向客服咨询（法务联系电话：021-34202780，客服联系电话：400-669-6868）。
</p>
<p></p>
  </div>
</template>
<script>
import Vue from 'vue'
import { NavBar,Icon } from 'vant'
import jsBridge from '../../../config/jsbridge-mini.js'

Vue.use(NavBar).use(Icon)
export default {
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight(){
jsBridge.openInBrowser('https://m.baidu.com');
    }
  },
}
</script>
<style lang="less" scoped>
.img{
  width: 0.6rem;
  margin-right: 0.2rem;
}
h2 {
  padding-top: 1.5rem;
  font-size: 0.5rem;
  text-align: center;
}
h3 {
  text-align: center;
  font-size: 0.5rem;
  padding-top: 0.5rem;
}
p {
  text-indent: 1rem;
  line-height: 0.773333rem;
  font-family: '仿宋';
  color: #000;
  font-size: 0.426667rem;
  padding: 0 0.2rem;
}
</style>
